import React from "react";
import cx from "classnames";

interface IQuoteTableProductContentProps {
    productName: string;
}

const QuoteTableProductContent: React.FC<IQuoteTableProductContentProps> = (props) => {
    const { productName } = props;

    return (
        <span className={cx(["width-full", "layout-inline-block", "text-align--center"])}>
            {productName}
        </span>
    );
};

export default React.memo(QuoteTableProductContent);
